import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import '../../../../../../../context/actions.js';
import '../../../../../../../context/reducer.js';
import { useReadyReaderProductData } from '../../../../../../../context/product-context-hooks.js';
import '../../../../../../../context/ProductContext.js';
import '../../../../../../../context/CmsContext.js';
import '@grandvisionhq/state';
import '../../../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@swc/helpers';
import '../../../../../../../types/product.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/carts-v2';
import { PowerDropdownContainer } from '../../../../../components/PowerDropdown/PowerDropdownContainer.js';
import '@grandvisionhq/lib-visuals';
import '../../../../../../../slots/context.js';
import '@grandvisionhq/content';
import { mapVariantsToPowerItems } from './utils/map-variants-to-power-items.js';

const ReadyReaderPowerSelector = ()=>{
    const { activeVariant , product  } = useReadyReaderProductData();
    const powerItems = mapVariantsToPowerItems(product.variants);
    const selectedPower = Object.values(powerItems).find((item)=>item.value === activeVariant.sku
    );
    const handleChange = (selectedItem)=>{
        DataLayer.pushEvent({
            event: 'readyreaders',
            eventAction: 'pdp select lens power',
            eventLabel: selectedItem.label
        });
    };
    return /*#__PURE__*/ React.createElement(PowerDropdownContainer, {
        label: "ready-reader-power-selector",
        onChange: handleChange,
        selectedSize: selectedPower,
        options: powerItems
    });
};

export { ReadyReaderPowerSelector };
//# sourceMappingURL=ReadyReaderPowerSelector.js.map
